export default __webpack_public_path__ + "static/media/sample_movie.21d55a62.xlsx";